<template>
    <div v-if="permissions && $getPermission(permissions,38).is_granted && topModels && topModels[0] && topModels[0].username && topModels[0].earnings" class="hidden sm:block sm:ml-24 fixed w-56 text-center border border-sepBorder rounded-lg h-full mt-2 py-5 pb-36 overflow-auto dark:text-dark.textOnBkg dark:border-dark.sepBorder overflow-x-hidden">
        <slot v-if="topModels && topModels[0] && topModels[0].username && topModels[0].earnings && !loading.topModels">
            <h2 class="font-bold text-2xl">{{ $t('top_model') }}</h2>
            <MazSelect
                class="w-36 mt-1"
                size="sm"
                :options="lastSixMonths.map(month => ({ label: month.label, value: month.value }))"
                v-model="selectedTopMonth"
            />
            <div class="grid grid-rows-3 gap-6 w-full mt-5">
                <div v-for="(t_model,t_i) in topModels" :key="t_i" class="text-8 rounded-lg text-center">
                    <font-awesome-icon :icon="['fas', 'crown']" class="absolute -mt-4 -ml-2.5 text-xl" :class="{'text-gold':t_i == 0, 'text-silver':t_i == 1, 'text-bronze':t_i == 2}" />
                    <div class="rounded-full h-36 w-36 border-6 mx-auto shadow bg-gray-200" :class="{'border-gold':t_i == 0, 'border-silver':t_i == 1, 'border-bronze':t_i == 2}" :style="'box-shadow: inset 0 0 5px rgba(0,0,0,0.3);background-image: url(&quot;' + t_model.avatar + '&quot;); background-size: cover; background-position: center center;'"></div>
                    <div class="rounded-full p-1 text-sm px-3 w-max mx-auto -mt-5 text-gray-800 font-bold" :class="{'bg-gold':t_i == 0, 'bg-silver':t_i == 1, 'bg-bronze':t_i == 2}" style="box-shadow: inset 0 0 5px rgba(0,0,0,0.3)">{{t_i+1}}</div>
                    <h4 class="mt-1.5 w-56 mx-auto truncate">{{t_model.name}} - {{t_model.platformName}}</h4>
                    <h3 class="font-bold text-2xl">{{t_model.earnings ? '$ ' + parseFloat(t_model.earnings).toFixed(2) : 'Missing data'}}</h3>
                </div>
            </div>
        </slot>
        <div v-else-if="loading.topModels">
            <font-awesome-icon icon="fas fa-spinner" class="animate-spin absolute top-1/3" />
        </div>
    </div>
    <div class="mr-1 sm:mr-5 dark:text-dark.textOnBkg" :class="permissions && $getPermission(permissions, 38).is_granted && topModels && topModels[0] && topModels[0].username && topModels[0].earnings ? 'sm:ml-82' : 'sm:ml-24'">
        <div class="sm:flex sm:justify-between">
            <div class="mt-2">
                <div class="sm:flex gap-2">
                    <button v-if="permissions && $getPermission(permissions, 6).is_granted"
                        @click="show_creator_modal(null)"
                        class="m-2 sm:m-0 bg-button dark:bg-growth rounded-lg cursor-pointer p-1.5 px-3 text-buttonText dark:text-black text-center font-semibold whitespace-nowrap">
                            <font-awesome-icon icon="fa-solid fa-plus" />
                            {{ $t('connect_a_creator') }}
                    </button>
                    <button v-if="permissions && $getPermission(permissions, 6).is_granted" @click="openBatchCreator_modal()" class="bg-button dark:bg-growth rounded-lg cursor-pointer p-1.5 px-3 text-buttonText dark:text-black text-center font-semibold whitespace-nowrap">
                        <font-awesome-icon :icon="['fas', 'folder-plus']" />
                        {{ $t('batch_adding') }}
                    </button>
                    <button @click="refreshModels()" class="ml-2 sm:ml-0 whitespace-nowrap border-2 border-button dark:border-growth dark:text-growth text-button font-semibold p-1 px-2.5 rounded-lg">
                        <font-awesome-icon icon="fa-solid fa-refresh" />
                        {{ $t('refresh') }}
                    </button>
                </div>
                <div class="whitespace-nowrap justify-between">
                    <button v-if="permissions && $getPermission(permissions, 8).is_granted" @click="showActive = !showActive" class="ml-2 sm:ml-0 block outline-0 mt-2 rounded-lg cursor-pointer text-button text-center dark:border-growth dark:text-growth text-sm">
                        <font-awesome-icon :icon="showActive ? 'fas fa-check-square' : 'far fa-square'" />
                        {{ $t('show_active_creators_only') }}
                    </button>
                </div>
            </div>
            <div>
                <div class="flex">
                    <div v-if="modelDataFiltered.length > 0" class="mt-2.5 mr-2">
                        <MazSelect
                            :options="[
                            { label: $t('earnings') + ': ' + $t('low_to_high'), value: 'earnings_asc' },
                            { label: $t('earnings') + ': ' + $t('high_to_low'), value: 'earnings_desc' },
                            { label: $t('salary') + ': ' + $t('low_to_high'), value: 'salary_asc' },
                            { label: $t('salary') + ': ' + $t('high_to_low'), value: 'salary_desc' },
                            { label: $t('ranking') + ': ' + $t('low_to_high'), value: 'ranking_asc' },
                            { label: $t('ranking') + ': ' + $t('high_to_low'), value: 'ranking_desc' },
                            ]"
                        :label="$t('sort_by')" v-model="order" size="sm" class="w-28" />
                    </div>
                    <div class="relative mt-2.5">
                        <button @click="showColumnDropdown = !showColumnDropdown" class="bg-mazUIBg text-mazUiText dark:bg-dark.mazUIBg dark:text-dark.mazUiText rounded-xl cursor-pointer p-2.5 px-3 border border-sepBorder dark:border-dark.mazUIBg text-center whitespace-nowrap text-xs" >
                            {{ $t('show_hide') }} <font-awesome-icon :icon="['fas', 'angle-down']" />
                        </button>
                        <div v-if="showColumnDropdown" class="absolute z-10 bg-mazUIBg dark:bg-dark.mazUIBg rounded-lg shadow-lg p-2 px-3 mt-1 z-50">
                            <div class="flex items-center mb-1 border-b border-sepBorder dark:border-dark.sepBorder pb-1">
                                <input type="checkbox" id="showAll" :checked="allColumnsVisible" @change="toggleAllColumns" class="mr-2" />
                                <label for="showAll" class="cursor-pointer">{{ $t('show_all') }}</label>
                            </div>
                            <div v-for="column in togglableColumns" :key="column.name" class="flex items-center">
                                <input type="checkbox" :id="column.name" v-model="columnVisibility[column.name]" class="mr-2" />
                                <label :for="column.name" class="whitespace-nowrap">{{ column.label }}</label>
                            </div>
                        </div>
                    </div>
                    <button class="block h-9 text-button border border-button dark:border-growth dark:text-growth ml-2 mt-2.5 rounded-lg p-1 px-3 cursor-pointer whitespace-nowrap" @click="exportToCSV">
                        <span ref="exportLoading" class="hidden">
                            <font-awesome-icon icon="fas fa-spinner" class="animate-spin mr-2" />
                        </span>
                        {{ $t('export') }}
                        <span class="hidden sm:contents"> {{ $t('to_csv') }}</span>
                    </button>
                </div>
            <div v-if="!isElectron" class="text-button dark:text-growth text-sm mt-1">
                *{{ $t('session_access_note') }}
                <router-link to="/tools" class="font-bold">CreatorXOne app</router-link>
            </div>
        </div>
    </div>

    <div class="overflow-x-auto">
        <div class="overflow-auto pb-10" style="height: calc(100vh - 120px);">
            <table class="bg-tableBG dark:bg-dark.tableBG mt-3 mx-auto whitespace-nowrap rounded-lg font-normal border border-sepBorder dark:border-dark.sepBorder table-auto w-full">
                <thead>
                    <tr class="top-0 sticky bg-gray-100 dark:bg-dark.panels z-10 border border-sepBorder dark:border-dark.sepBorder rounded-t">
                        <th v-if="isElectron" class="px-2 border-r border-sepBorder dark:border-dark.sepBorder">
                            {{ $t('session') }}
                        </th>
                        <th class="py-2 pl-2 px-2 border-r border-sepBorder dark:border-dark.sepBorder">
                            <span @click="toggleSearch('stage_name')" class="cursor-pointer select-none">
                                {{ $t('creator') }}
                                <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="text-sm ml-1 text-blueColor cursor-pointer"/>
                            </span>
                            <font-awesome-icon v-if="search.stage_name.length > 0" @click="clearSearch('stage_name')" icon="fa-solid fa-filter-circle-xmark" class="ml-1.5 text-sm text-decline cursor-pointer"/>
                            <div v-if="searchOpen.stage_name === true" class="w-max bg-gray-100 rounded-lg absolute p-2 pt-0.5 font-light -ml-2 border border-t-0 border-sepBorder dark:border-dark.sepBorder shadow-light dark:shadow-dark">
                                <input type="search" ref="stage_nameInput" placeholder="Search..." class="p-0.5 px-2 w-36 rounded" v-model="search.stage_name" @keyup.enter="hideSearch('stage_name')" @blur="hideSearch('stage_name')" />
                                <font-awesome-icon icon="fa-solid fa-times" class="cursor-pointer ml-2" @click="hideSearch('stage_name')" />
                            </div>
                        </th>
                        <th v-if="columnVisibility.platform" class="cursor-pointer w-32 py-2 px-2 text-center relative border-r border-sepBorder dark:border-dark.sepBorder" @mouseover="platformFilter = true" @mouseleave="platformFilter = false">
                            {{ $t('platform') }}
                            <font-awesome-icon icon="fa-solid fa-angle-down" class="text-blueColor" />
                            <div v-if="platformFilter === true" class="w-max bg-gray-100 dark:bg-dark.panels mt-1 dark:text-dark.textOnBkg rounded-lg absolute p-2 pt-0.5 text-left font-light -ml-2 border border-t-0 border-sepBorder dark:border-dark.sepBorder shadow-light dark:shadow-dark">
                                <slot v-for="(platform, index) in platformsList" :key="index">
                                    <div @click="togglePlatform(index)" class="cursor-pointer">
                                        <input type="checkbox" :id="`platform-${index}`" :value="index" v-model="filteredPlatform" class="mr-2" />
                                        <span>{{ platform }}</span>
                                    </div>
                                </slot>
                            </div>
                        </th>
                        <th v-if="columnVisibility.assignment" class="py-2 px-1 border-r border-sepBorder dark:border-dark.sepBorder">
                            {{ $t('assignment') }}
                        </th>
                        <th v-if="columnVisibility.fans" class="py-2 px-2.5 relative border-r border-sepBorder dark:border-dark.sepBorder">
                            {{ $t('fans') }}
                            <iconfilteringArraysComponent :filters="filters.fans" />
                        </th>
                        <th v-if="columnVisibility.ranking" class="py-2 px-2.5 relative pr-2 border-r border-sepBorder dark:border-dark.sepBorder">
                            {{ $t('ranking') }}
                            <iconfilteringArraysComponent :filters="filters.ranking" />
                        </th>
                        <th v-if="permissions && $getPermission(permissions, 38).is_granted && columnVisibility.netEarnings" class="py-2 px-5 border-r border-sepBorder dark:border-dark.sepBorder">
                            {{ $t('net_earnings') }}
                        </th>
                        <th v-if="permissions && $getPermission(permissions, 38).is_granted && columnVisibility.creatorSalary" class="py-2 px-5 border-r border-sepBorder dark:border-dark.sepBorder">
                            {{ $t('creator') }} {{ $t('salary') }}
                        </th>
                        <th v-if=" permissions && $getPermission(permissions, 38).is_granted && columnVisibility.profit" class="py-2 px-5 border-r border-sepBorder dark:border-dark.sepBorder">
                            {{ $t('profit') }}
                        </th>
                        <th v-if="1 == 2" class="py-2 px-4">{{ $t('Metrics') }}</th>
                        <th class="py-2 px-4 text-center" v-if="permissions && ($getPermission(permissions, 38).is_granted || $getPermission(permissions, 13).is_granted || $getPermission(permissions, 7).is_granted)">
                            {{ $t('actions') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <slot v-if="modelDataFiltered.length > 0 && !loading.models">
                        <tr v-for="(model, index) in modelDataFiltered" :key="index" class="cursor-pointer hover:bg-gray-200 hover:dark:bg-dark.panels transition-bg"
                            :class="{
                                'opacity-50': model.free?.active == 0,
                                'bg-orange-200 dark:bg-opacity-40': model.updated === true,
                            }"
                            @click="show_creator_modal(model.pair_id)" >
                            <td v-if="isElectron" class="border-t border-l border-sepBorder dark:border-dark.sepBorder px-1">
                                <div v-if="model.free.active == 1" @click.stop @click="open_sessions_modal(index)" class="p-1.5 rounded-lg text-sm font-semibold bg-growth text-white dark:text-black cursor-pointer text-center">
                                    {{ $t('open') }}
                                </div>
                            </td>
                            <td class="p-2 border-t border-b border-sepBorder dark:border-dark.sepBorder relative">
                                <div class="flex items-center gap-3">
                                    <div class="w-14 relative">
                                        <div class="rounded-full h-12 w-12 mx-auto shadow bg-gray-200 dark:bg-gray-700"
                                            :style="{backgroundImage: model?.avatar ? `url(${model?.avatar})` : null, backgroundSize: 'cover', backgroundPosition: 'center'}"></div>
                                        <div class="cursor-help animate-ping w-2 h-2 rounded-full absolute bg-decline ml-12 -mt-12 shadow" v-if="model.platform <= 2 && !model.free.scraped" ></div>
                                        <div :title="$t('scraper_notice')" class="cursor-help w-2 h-2 rounded-full absolute bg-decline ml-12 -mt-12 shadow" v-if="model.platform <= 2 && !model.free.scraped" ></div>
                                        <div v-if="model.new" class="absolute rounded bg-growth text-black text-xs font-semibold -mt-3.5 ml-1.5 p-0.5 px-2">NEW</div>
                                    </div>
                                    <div class="inline">
                                        <div class="font-semibold whitespace-nowrap capitalize">
                                            {{ model.free.name }}
                                        </div>
                                        <div class="text-sm font-lighter mt-0.5">
                                            {{ model.username ? '@' + model.username : null }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td v-if="columnVisibility.platform" class="border-t border-b border-sepBorder dark:border-dark.sepBorder px-3">
                                <div class="w-20 rounded-lg mx-auto" :class="{'dark:bg-gray-500 rounded-full w-max p-1': model.platform == 4}">
                                    <img
                                    :src="$platformLogo(model)"
                                    :title="model?.platformName"
                                    :alt="model?.platformName"
                                    class="h-6 mx-auto p-0.5"
                                    />
                                </div>
                            </td>
                            <td v-if="columnVisibility.assignment" class="px-2.5 border-t border-b border-sepBorder dark:border-dark.sepBorder text-sm text-center">
                                <div v-if="model?.identifier">
                                    <span v-for="(part, index) in model.identifier.split('-')" :key="index" >
                                        {{ part }}<br v-if="index < model.identifier.split('-').length - 1" />
                                    </span>
                                </div>
                            </td>
                            <td v-if="columnVisibility.fans" class="px-2.5 border-t border-b border-sepBorder dark:border-dark.sepBorder text-center">
                                <div>{{ model.fans.data[model?.fans?.data?.length - 1] ?? '-' }}</div>
                            </td>
                            <td v-if="columnVisibility.ranking" class="px-5 border-t border-b border-sepBorder dark:border-dark.sepBorder text-center" :class="{ 'text-blueColor font-bold': model.performerTop < 5 }">
                                <div>{{ model.performerTop < 100 ? model.performerTop + '%' : '-' }}</div>
                            </td>
                            <td v-if="permissions && $getPermission(permissions, 38).is_granted && columnVisibility.netEarnings" class="px-5 border-t border-b border-sepBorder dark:border-dark.sepBorder text-center">
                                <div>$ {{ model.earnings ? model.earnings.sum.toFixed(2) : 0 }}</div>
                            </td>
                            <td v-if="permissions && $getPermission(permissions, 38).is_granted && columnVisibility.creatorSalary" class="px-5 border-t border-b border-sepBorder dark:border-dark.sepBorder text-center">
                                <div>
                                    {{
                                        model.commission > 0 ? '$ ' + (model.commission_type == '%'
                                            ? (model.earnings.sum * (model.commission / 100)).toFixed(2)
                                            : model.commission)
                                        : '-'
                                    }}
                                </div>
                            </td>
                            <td v-if="permissions && $getPermission(permissions, 38).is_granted && columnVisibility.profit" class="px-5 border-t border-b border-sepBorder dark:border-dark.sepBorder text-center">
                                <div v-if="model.earnings.data.length > 0 && model.commission > 0">
                                    $ {{ (model.earnings.sum - (model.commission_type == '%' ? (model.earnings.sum * (model.commission / 100)).toFixed(2) : model.commission)).toFixed(2) }}
                                </div>
                                <div v-else-if="model.earnings.data.length > 0 && model.commission <= 0">
                                    $ {{ model.earnings.data ? model.earnings.sum.toFixed(2) : 0 }}
                                </div>
                                <div v-else>-</div>
                            </td>
                            <td class="px-2.5 border-t border-b border-sepBorder dark:border-dark.sepBorder text-center text-button dark:text-dark.textOnBkg" v-if="
                                permissions &&
                                ($getPermission(permissions, 38).is_granted ||
                                $getPermission(permissions, 13).is_granted ||
                                $getPermission(permissions, 7).is_granted)">
                                <button v-if="permissions && $getPermission(permissions, 38).is_granted" type="button" @click.stop="show_creator_graph(index)" :title="$t('Analytics')" class="px-2 -mt-1 cursor-pointer" >
                                    <font-awesome-icon icon="fa-solid fa-chart-column" class="text-growth text-lg cursor-pointer" />
                                </button>
                                <font-awesome-icon v-if="permissions && $getPermission(permissions, 13).is_granted" @click.stop="sessionModal(index)" :title="$t('session_management')" icon="fa-solid fa-server" class="px-2" />
                                <font-awesome-icon v-if="permissions && $getPermission(permissions, 7).is_granted" @click.stop="modelArchive(modelDataFiltered[index].free.active, index)" :title="$t('archive')" icon="fas fa-archive" class="px-2" />
                            </td>
                        </tr>
                    </slot>
                    <slot v-else-if="loading.models">
                        <tr>
                            <td :colspan="visibleColumnCount" class="text-center py-10 pb-20" >
                            <font-awesome-icon icon="fas fa-spinner" class="text-xl mt-10 animate-spin" />
                            </td>
                        </tr>
                    </slot>
                    <slot v-else>
                        <tr>
                            <td :colspan="visibleColumnCount">
                                <h1 class="text-center text-2xl font-semibold text-contentText dark:text-dark.textOnBkg my-16" >
                                    {{ $t('no_creator_account') }}
                                </h1>
                                <img src="@/assets/images/photoshoot.svg" class="w-full sm:h-96 mx-auto mt-16 mb-10" />
                            </td>
                        </tr>
                    </slot>
                </tbody>
            </table>
        </div>
    </div>
</div>

<transition name="zoom-fade">
    <section v-if="modal.display" @click="modal.display = false" class="backdrop-blur w-full h-full fixed inset-0 bg-gray-700 bg-opacity-30 z-50 flex justify-center items-center px-4 text-black">
        <section @click.stop class="bg-white dark:bg-dark.bkg dark:text-dark.textOnBkg rounded-lg max-h-screen mx-auto my-auto p-8 px-6 sm:p-10 z-50 overflow-auto relative" :class="modal.type == 'add_batch_creators' ? 'max-w-screen' : (modal.type == 'graph' ? 'sm:max-w-7xl' : (modal.type == 'session_electron' ? 'sm:max-w-3xl' : 'sm:max-w-5xl'))">
            <font-awesome-icon @click="modal.display = false" icon="fas fa-xmark" class="transition absolute p-6 top-0 right-0 text-xl cursor-pointer hover:opacity-50" />
            <div v-if="modal.type != 'model' && modal.type != 'add_batch_creators'" class="col-span-2 grid grid-cols-2 gap-2 sm:gap-10 w-full pb-5 border-b border-sepBorder dark:border-dark.sepBorder" :class="[isElectron ? 'border-none' : null, modal.type == 'graph' ? 'sm:grid-cols-6' : 'sm:grid-cols-5']">
                <div class="flex sm:w-max">
                    <div class="hidden sm:block rounded-full h-14 w-14 mx-auto shadow bg-gray-200 mr-3" :style="{ backgroundImage: `url(${modelDataFiltered[modal.index].avatar})`, backgroundSize: 'cover', backgroundPosition: 'center' }"></div>
                    <div class="w-max leading-5">
                        <div class="font-bold w-52 truncate">{{modelDataFiltered[modal.index].free.name}}</div>
                        <div class="text-xs">{{modelDataFiltered[modal.index].username ? '@'+modelDataFiltered[modal.index].username : null}}</div>
                        <div class="w-20">
                            <img :src="$platformLogo(modelDataFiltered[modal.index])" :title="modelDataFiltered[modal.index].platformName" :alt="modelDataFiltered[modal.index].platformName" class="h-3.5 mt-1"/>
                        </div>
                    </div>
                </div>
                <div></div>
                <div class="text-right"><strong>{{ modelDataFiltered[modal.index].fans.data[modelDataFiltered[modal.index]?.fans?.data?.length-1] ?? '-' }}</strong><br /><small class="text-blueColor font-semibold">{{ $t('subscribers') }}</small></div>
                <div class="text-right"><strong>${{ modelDataFiltered[modal.index]?.earnings ? modelDataFiltered[modal.index].earnings.sum.toFixed(2) : 0}}</strong><br /><small class="text-blueColor font-semibold">{{ $t('earnings') }}</small></div>
                <div class="text-right pr-5"><strong>{{modelDataFiltered[modal.index].performerTop < 100 ? modelDataFiltered[modal.index].performerTop+'%' : '-'}}</strong><br /><small class="text-blueColor font-semibold">{{ $t('ranking') }}</small></div>
                <div v-if="modal.type == 'graph'" class="col-span-2 sm:col-span-1">
                    <MazPicker
                    v-model="dRange"
                    size="sm"
                    pickerPosition="right"
                    :label="$t('filter')"
                    :max-date="new Date().toISOString().split('T')[0]"
                    double
                    />
                </div>
            </div>
            <add-batch-models v-if="modal.type == 'add_batch_creators'" @close="handleClose" />
            <add-model v-if="modal.type == 'model'" :noarrow="true" :model_id_prop="model_pair_id" @close="handleClose" />
            <session-management v-else-if="modal.type == 'session'" :model_pair_id="modelDataFiltered[modal.index].pair_id" @close="handleClose" />
            <session-electron v-else-if="modal.type == 'session_electron'" :permissions="permissions" :model_data="modelDataFiltered[modal.index]" @close="handleClose" />
            <div v-else-if="modal.type == 'graph'" class="w-full grid grid-cols-1 sm:grid-cols-2">
                <div class="h-60 sm:h-96">
                    <chart-component v-if="g_data.earnings?.data" :g_data="g_data.earnings" :chartType="'bar'" :graphLabel="$t('earnings')" :isDarkMode="isDarkMode" :colors="isDarkMode ? ['#70C1B2','#333333'] : ['#70C1B2','#FFFFFF']" />
                </div>
                <div class="h-60 sm:h-96">
                    <chart-component v-if="g_data.fans?.data" :g_data="g_data.fans" :chartType="'line'" :graphLabel="$t('subscribers')" :isDarkMode="isDarkMode" :colors="isDarkMode ? ['#70C1B2','#333333'] : ['#70C1B2','#FFFFFF']" />
                </div>
            </div>
        </section>
    </section>
</transition>

</template>

<script setup>
    import toolTip from "@/components/toolTip.vue"
    import AddModel from "@/components/settings/models/modelsForm.vue"
    import AddBatchModels from "@/components/settings/models/batchModelsForm.vue"
    import ChartComponent from "@/components/charts/chart_comp.vue"
    import sessionManagement from "@/components/settings/sessionManagement.vue"
    import sessionElectron from "@/components/settings/sessionElectron.vue"
    import iconfilteringArraysComponent from "@/components/iconfilteringArraysComponent.vue"
</script>

<script>
import { useAuthStore } from '@/stores/auth';
import { get_models, archive_model, get_top_models, get_model_graph, save_fingerprint } from '@/api/api';

export default {
    components() {
        toolTip, AddBatchModels, AddModel, ChartComponent, sessionManagement, sessionElectron, iconfilteringArraysComponent
    },
    data() {
        return {
            selectedTopMonth: null,
            platformFilter:false,
            platformsList: ['Onlyfans', 'Fansly', 'Reddit', 'X', 'Sex.com'],
            isElectron: this.$cookies.get('desktop_app_token') == import.meta.env.VITE_API_INTERNAL_KEY_LIST,
            filteredPlatform: [],
            dRange: [this.$moment().startOf('month').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')],
            modal: {display: false, type: null, index: 0},
            g_data: {earnings: null, fans: null},
            graph_dates: 'this_month',
            custom_end_date: null,
            modelData: [],
            loading: {
                topModels: true,
                models: true
            },
            model_pair_id: null,
            order: '',
            showActive: true,
            topModels: [],
            sessionsList: [],
            search: {
                stage_name: '',
                username: ''
            },
            searchOpen: {
                stage_name: false,
                username: false
            },
            filters:{
                platform: [
                    {name: this.$t('all'), flag: true, type:'all'},
                    {name: 'OnlyFans', flag: true, type:'string', value:'OnlyFans'},
                    {name: 'Fansly', flag: true, type:'string', value:'Fansly'},
                ],
                fans:[
                    {name: this.$t('all'), flag: true, type:'all'},
                    {name: '< 1000', flag: true, type:'range', value: [0,1000]},
                    {name: '1000 - 5000', flag: true, type:'range', value: [1000,5000]},
                    {name: '5000 - 10000', flag: true, type:'range', value: [5000,10000]},
                ],
                ranking:[
                    {name: this.$t('all'), flag: true, type:'all'},
                    {name: '< 1%', flag: true, type:'range', value: [0,1]},
                    {name: '1% - 5%', flag: true, type:'range', value: [1,5]},
                    {name: '5% - 25%', flag: true, type:'range', value: [5,25]},
                    {name: '> 25%', flag: true, type:'range', value: [25,0]},
                ]
            },
            showColumnDropdown: false,
            columnVisibility: {
                platform: true,
                assignment: true,
                fans: true,
                ranking: true,
                netEarnings: true,
                creatorSalary: true,
                profit: true,
            },
            isFetching: false
        }
    },
    watch: {
        selectedTopMonth: function (o,n) {
            this.getTopModels()
        },
        dRange: function (n,o) {
            if (o != n && n.start && n.end && !this.isFetching) {
                this.isFetching = true;
                this.order_g_data();
            }
        },
        order: function(o,n) {
            const getEarningsTotal = (earnings) => earnings ? earnings.sum : 0;
            const getSalary = (model) => {
                if (model.commission > 0) {
                    return model.commission_type === "%" ? getEarningsTotal(model.earnings) * (model.commission / 100) : model.commission;
                }
                return 0;
            };
            
            const sortFunctions = {
                '': (a, b) => a.free.id - b.free.id,
                'earnings_asc': (a, b) => getEarningsTotal(a.earnings) - getEarningsTotal(b.earnings),
                'earnings_desc': (a, b) => getEarningsTotal(b.earnings) - getEarningsTotal(a.earnings),
                'salary_asc': (a, b) => getSalary(a) - getSalary(b),
                'salary_desc': (a, b) => getSalary(b) - getSalary(a),
                'ranking_asc': (a, b) => a.performerTop - b.performerTop,
                'ranking_desc': (a, b) => b.performerTop - a.performerTop
            };
            
            if (this.order in sortFunctions) {
                this.modelData.sort(sortFunctions[this.order]);
            }
        }
    },
    computed: {
        authStore() {
            return useAuthStore();
        },
        myself() {
            return this.authStore.myself;
        },
        permissions() {
            return this.authStore.permissions;
        },
        allColumnsVisible() {
            return Object.values(this.columnVisibility).every((visible) => visible);
        },
        togglableColumns() {
            return [
            { name: 'platform', label: this.$t('platform'), condition: true },
            { name: 'assignment', label: this.$t('assignment'), condition: true },
            { name: 'fans', label: this.$t('fans'), condition: true },
            { name: 'ranking', label: this.$t('ranking'), condition: true },
            {
                name: 'netEarnings',
                label: this.$t('net_earnings'),
                condition:
                this.permissions && this.$getPermission(this.permissions, 38).is_granted,
            },
            {
                name: 'creatorSalary',
                label: this.$t('creator') + ' ' + this.$t('salary'),
                condition:
                this.permissions && this.$getPermission(this.permissions, 38).is_granted,
            },
            {
                name: 'profit',
                label: this.$t('profit'),
                condition:
                this.permissions && this.$getPermission(this.permissions, 38).is_granted,
            },
            ].filter((column) => column.condition);
        },
        visibleColumnCount() {
            let count = 0;
            count++; // Creator (always visible)
            if (this.columnVisibility.platform) count++; // Platform
            if (this.columnVisibility.assignment) count++; // Assignment
            if (this.columnVisibility.fans) count++; // Fans
            if (this.columnVisibility.ranking) count++; // Ranking
            if (this.permissions && this.$getPermission(this.permissions, 38).is_granted) {
                if (this.columnVisibility.netEarnings) count++; // Net Earnings
                if (this.columnVisibility.creatorSalary) count++; // Creator Salary
                if (this.columnVisibility.profit) count++; // Profit
            }
            if (this.permissions && (this.$getPermission(this.permissions, 38).is_granted || this.$getPermission(this.permissions, 13).is_granted || this.$getPermission(this.permissions, 7).is_granted)) {
                count++; // Actions (always visible if rendered)
            }
            return count;
        },
        isDarkMode() {
            //pull from the localstorage
            return localStorage.getItem('darkMode') === 'true';
        },
        lastSixMonths() {
            let months = [];
            for (let i = 0; i < 6; i++) {
                let month = this.$moment().subtract(i, 'months');
                months.push({
                    value: month.format('MM-YYYY'),
                    label: month.format('MMMM YYYY')
                });
            }
            return months;
        },
        modelDataFiltered() {
            if (Array.isArray(this.modelData)) {
                let filteredData = this.modelData;
                
                // Filter by active status if showActive is true
                if (this.showActive) {
                    filteredData = filteredData.filter(model => (
                    model.free ? model?.free?.active === 1 : model.active === 1
                    )
                    );
                }
                
                // Filter by stage name if search input is populated
                if (this.search.stage_name) {
                    filteredData = filteredData.filter(model =>
                    model.free.name.toLowerCase().includes(this.search.stage_name.toLowerCase())
                    );
                }
                
                if (this.filteredPlatform.length > 0) {
                    filteredData = filteredData.filter(model => this.filteredPlatform.includes(parseInt(model.platform)-1));
                }
                
                if (this.search.username) {
                    filteredData = filteredData.filter(model =>
                    model.username.toLowerCase().includes(this.search.username.toLowerCase())
                    );
                }
                
                return filteredData;
            } else {
                return [];
            }
        }
    },
    methods: {
        toggleAllColumns(event) {
            const isChecked = event.target.checked;
            for (const column in this.columnVisibility) {
                this.columnVisibility[column] = isChecked;
            }
        },
        togglePlatform(index) {
            const idx = this.filteredPlatform.indexOf(index);
            if (idx > -1) {
                this.filteredPlatform.splice(idx, 1);
            } else {
                this.filteredPlatform.push(index);
            }
        },
        toggleSearch(field) {
            this.searchOpen[field] = !this.searchOpen[field];
            
            // When the search input is shown, focus on it
            this.$nextTick(() => {
                if (this.searchOpen[field]) {
                    this.$refs[`${field}Input`].focus();
                }
            });
        },
        hideSearch(field) {
            this.searchOpen[field] = false;
        },
        clearSearch(field) {
            this.search[field] = '';
        },
        refreshModels() {
            this.loading.models = true;
            this.getModelData();
        },
        async open_sessions_modal(index) {
            if (!this.isElectron) {
                alert($t('download_and_use_cx1'));
                return;
            }
            this.modal.display = true;
            this.modal.type = 'session_electron';
            this.modal.index = index;
        },
        async modelArchive(action, index) {
            if (confirm(this.$t('you_sure') + (action == 1 ? this.$t('archive_model') : this.$t('unarchive_model')))) {
                const model = this.modelData.find(m => m.pair_id === this.modelDataFiltered[index].pair_id);
                if (model) {
                    model.free.active = !action;
                    await archive_model(this.$cookies.get('userToken'),this.$cookies.get('c_id'),model.free.active,model.pair_id,null);
                }
            }
        },
        async handleClose(pair_id) {
            if (!pair_id) {
                this.modal.display = false;
                this.refreshModels();
            }
            const model = this.modelData.find(m => m.pair_id === pair_id);
            //update the data from the database
            let updatedModel = await get_models(this.$cookies.get('userToken'),this.$cookies.get('c_id'),null,model.pair_id)
            console.log(updatedModel);
            //update modelData with the new data
            if (model) {
                let index = this.modelData.indexOf(model);
                this.modelData[index].identifier = updatedModel.identifier;
                this.modelData[index].free.name = updatedModel.free.name;
            } else {
                //refresh because a new model was added
                this.refreshModels();
            }
            //add a new parameter to model - model.updated = true
            if (model) {
                model.updated = true;
                this.modal.display = false;
                setTimeout(() => model.updated = false, 800);
            } else {
                //refresh because a new model was added
                this.modal.display = false;
                this.refreshModels();
            }
        },
        sessionModal(index) {
            this.modal.display = true
            this.modal.type = 'session'
            this.modal.index = index
        },
        openBatchCreator_modal() {
            this.modal.display = true;
            this.modal.type = 'add_batch_creators';
        },
        show_creator_modal(pair_id = null) {
            if (this.permissions && this.$getPermission(this.permissions,7).is_granted) {
                this.model_pair_id = pair_id;
                this.modal.display = true;
                this.modal.type = 'model';
            }
        },
        show_creator_graph(index) {
            this.modal.display = true;
            this.modal.type = 'graph';
            this.modal.index = index;
            this.g_data.earnings = {data: this.modelDataFiltered[index].earnings.data, labels: this.modelDataFiltered[index].earnings.labels};
            this.g_data.fans = {data: this.modelDataFiltered[index].fans.data, labels: this.modelDataFiltered[index].fans.labels};
            this.ordered_g_data = this.g_data;
        },
        async getModelData() {
            this.modelData = await get_models(this.$cookies.get('userToken'),this.$cookies.get('c_id'),null,null,null,0,0,1);
            this.loading.models = false;
        },
        
        async getTopModels() {
            this.loading.topModels = true;
            let date = this.$moment(this.selectedTopMonth, "MM-YYYY");
            let startOfMonth = date.startOf('month').format('YYYY-MM-DD');
            let endOfMonth = date.endOf('month').format('YYYY-MM-DD');
            this.topModels = await get_top_models(this.$cookies.get('userToken'),this.$cookies.get('c_id'), startOfMonth, endOfMonth, 3);
            if (this.topModels && this.topModels.length == 0) {
                //get data for the previous month
                date = this.$moment(this.selectedTopMonth, "MM-YYYY").subtract(1, 'months');
                startOfMonth = date.startOf('month').format('YYYY-MM-DD');
                endOfMonth = date.endOf('month').format('YYYY-MM-DD');
                this.topModels = await get_top_models(this.$cookies.get('userToken'),this.$cookies.get('c_id'), startOfMonth, endOfMonth, 3);
            }
            setTimeout(() => {
                this.loading.topModels = false;
            }, 500);
        },
        async order_g_data() {
            let dateFrom = this.dRange.start;
            let dateTo = this.dRange.end;
            
            this.g_data.earnings = await get_model_graph(this.$cookies.get('userToken'), this.$cookies.get('c_id'), 'earnings', dateFrom, dateTo, this.modelData[this.modal.index].free.id);
            this.g_data.fans = await get_model_graph(this.$cookies.get('userToken'), this.$cookies.get('c_id'), 'fans', dateFrom, dateTo, this.modelData[this.modal.index].free.id);
            this.isFetching = false;
        },
        exportToCSV(){
            this.$refs.exportLoading.classList.remove('hidden');
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += this.$t('creators_csv_columns');
            let platform,fans,ranking,net_earning,salary,profit;
            
            this.modelDataFiltered.forEach((model) => {
                platform = model.platform == 1 ? 'OnlyFans' : 'Fansly';
                fans = model.fans.data[model.fans.data.length-1] ?? 0;
                ranking = model.performerTop < 100 ? model.performerTop+'%' : '-';
                net_earning =  '$' + model.earnings ? model.earnings.sum.toFixed(2) : 0
                salary = model.commission > 0 ? '$ '+(model.commission_type == "%" ? (model.earnings.sum * (model.commission/100)).toFixed(2) : model.commission) : "-";
                if(model.earnings.data.length>0 && model.commission > 0){
                    profit = '$ '+(model.earnings.sum - ( model.commission_type == "%" ? (model.earnings.sum * (model.commission/100)).toFixed(2) : model.commission )).toFixed(2);
                } else if(model.earnings.data.length>0 && model.commission <= 0){
                    profit = '$ ' + model.earnings.data ? model.earnings.sum.toFixed(2) : 0;
                } else{
                    profit = '-';
                }
                
                csvContent += `${model.free.name},${platform},@${model.username},${fans},${ranking},${net_earning},${salary},${profit}\n`;
            });
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `${this.$t('Creators')}.csv` );
            document.body.appendChild(link); // Required for FF
            link.click();
            this.$refs.exportLoading.classList.add('hidden');
        }
    },
    async mounted() {
        const currentDate = new Date();
        currentDate.setMonth(currentDate.getMonth()); // Subtract 1 month from the current date
        const month = currentDate.getMonth() + 1; // Adding 1 to get month in range 1-12
        
        this.selectedTopMonth = `${month.toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
        
        this.getModelData();
        
        if (window && window.electron && window.electron.getFingerprint) {
            try {
                const fingerprint = await window.electron.getFingerprint();
                if (fingerprint) {
                    await save_fingerprint(this.$cookies.get('userToken'), this.$cookies.get('c_id'), fingerprint);
                }
            } catch (error) {
                console.error('Error sending fingerprint:', error);
            }
        }
    }
}
</script>

<style scoped>
.zoom-fade-enter-active {
    transition: all .3s ease;
}
.zoom-fade-leave-active {
    transition: all .3s ease;
}
.zoom-fade-enter-from, .zoom-fade-leave-to {
    transform: scale(0.9);
    opacity: 0;
}
.transition-bg {
    transition: background-color 0.5s ease;
}
</style>